import * as React from 'react';
import { withRootElement } from '../../../../../../slatePlugins/common/hocs/current-element.store';
import { TableBaseProps } from '../AdminView/types';
import styled from 'styled-components';
import { colorsV2 } from '../../../../../colors-v2';
import { getSlateEditorValue, isEmptySlateNodeValue } from '@doltech/utils/lib/editor';
import { InputCaptionTableComponentReadOnly } from '../../../BlogEditor/MediaLogic/component/InputCaptionTableComponentReadOnly';

const Table = styled.table`
  border: 1px solid transparent !important;

  tr {
    .border {
      border-width: 1px !important;
    }

    &:hover {
      cursor: grabbing;
      background-color: ${colorsV2.blue5};
    }
  }
  caption {
    caption-side: top;
  }

  thead {
    tr {
      .border {
        border-width: 1px 1px 0 !important;
      }
    }
  }
  tbody {
    display: contents !important;
  }
`;

interface AdminTableProps extends TableBaseProps {}

export const AdminTableReadOnly = withRootElement((props: AdminTableProps) => {
  const { element, children } = props;
  const childrenHeader = children?.[0];
  const childrenBody = children?.slice(1);

  const cellWidths = React.useMemo(
    () =>
      (element?.cellsWidth || []).map((cellWidth) => {
        if (typeof cellWidth === 'string') {
          return Number(cellWidth.replace('px', '')) || 213;
        }
        return cellWidth;
      }),
    [element?.cellsWidth]
  );
  const isEmptyCaption = isEmptySlateNodeValue(getSlateEditorValue(element?.caption));

  return (
    <Table className="admin-table-container">
      {!isEmptyCaption && (
        <caption>
          <InputCaptionTableComponentReadOnly
            caption={getSlateEditorValue(element?.caption)}
            isReadOnly
          />
        </caption>
      )}
      <colgroup>
        {(cellWidths as Array<number>).map((width: number, index) => (
          <col style={{ width }} key={index} />
        ))}
      </colgroup>
      <thead>{childrenHeader}</thead>
      <tbody>{childrenBody}</tbody>
    </Table>
  );
});
